export function formatDate(dateString: string | null): string {
  if (!dateString) return '-';

  // 1) Datum aus dem ISO-String parsen (UTC-Interpretation)
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-'; // ungültiges Datum abfangen

  // 2) Lokale Zeitzone des Nutzers ermitteln
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // 3) Datum/Uhrzeit im deutschen Format (ohne Wochentag & Zeitzone)
  const germanOptions: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: userTimeZone
  };
  const germanFormatter = new Intl.DateTimeFormat('de-DE', germanOptions);
  const germanFormatted = germanFormatter.format(date);

  // 4) Wochentag separat formatieren (neutral / nördliche Sprache)
  const weekdayFormatter = new Intl.DateTimeFormat('de-DE', {
    weekday: 'long',
    timeZone: userTimeZone
  });
  const weekday = weekdayFormatter.format(date);

  // 5) Wochentag + Datum/Uhrzeit kombinieren
  const formattedDate = `${weekday}, ${germanFormatted}`;

  // 6) Zeitdifferenz berechnen
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  const timeAgo =
    diffMinutes < 1
      ? 'gerade eben'
      : diffMinutes < 60
        ? `vor ${diffMinutes} Minuten`
        : diffHours < 24
          ? `vor ${diffHours} Stunden`
          : `vor ${diffDays} Tagen`;

  // 7) Finalen String zurückgeben
  return `${formattedDate} (${timeAgo})`;
}

export function formatDateOnly(dateString: string | null): string {
  if (!dateString) return '-';

  // 1) Datum aus dem ISO-String parsen
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-'; // ungültiges Datum abfangen

  // 2) Datum im deutschen Format (ohne Uhrzeit)
  const germanOptions: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  };
  const germanFormatter = new Intl.DateTimeFormat('de-DE', germanOptions);
  const germanFormatted = germanFormatter.format(date);

  // 3) Formatiertes Datum zurückgeben
  return germanFormatted;
}

export function formatDateOnlyWithRelative(dateString: string | null): string {
  if (!dateString) return '-';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-';

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // 1) Datum im deutschen Format OHNE Uhrzeit
  const germanOptions: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: userTimeZone
  };
  const germanFormatted = new Intl.DateTimeFormat('de-DE', germanOptions).format(date);

  // 2) Wochentag separat formatieren
  const weekday = new Intl.DateTimeFormat('de-DE', {
    weekday: 'long',
    timeZone: userTimeZone
  }).format(date);

  // 3) Zeitdifferenz berechnen (Relative Zeit)
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  const timeAgo =
    diffMinutes < 1
      ? 'gerade eben'
      : diffMinutes < 60
        ? `vor ${diffMinutes} Min.`
        : diffHours < 24
          ? `vor ${diffHours} Std.`
          : `vor ${diffDays} Tagen`;

  // 4) Finaler String: Wochentag, Datum (Relative Zeit)
  // Beispiel: "Dienstag, 10.02.2026 (vor 2 Tagen)"
  return `${weekday}, ${germanFormatted} (${timeAgo})`;
}
